export default __webpack_public_path__ + "static/media/betterplace-select-logo-dark-theme.8aaca13a.svg";